import { render, staticRenderFns } from "./FormDetails.vue?vue&type=template&id=275eeabd"
import script from "./FormDetails.vue?vue&type=script&lang=js"
export * from "./FormDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports